module.exports = "/fonts/vendor/@bcgov/bootstrap-theme/dist/bc-sans/BCSans-Regular.woff2?2a99e05855a00d22c6ea78b95a634569";